export default __webpack_public_path__ + "static/media/verify.5bd50072.svg";